module.exports = __webpack_public_path__ + "img/fileremove.7f9ec20b.svg";